export default "__VITE_ASSET__CdM1WcV4__"